import { Button } from '@liveauctioneers/hammer-ui-core/button';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import { BodyPrimary, H2, H5 } from '@liveauctioneers/hammer-ui-core/text';
import { useState } from 'react';

import { useTrackPurchaseProtectionFileAClaimAnalytics } from '@/utils/amplitude/analytics/purchaseProtection/trackPurchaseProtectionFileAClaim.analytics';

import { ImageComponent } from '../ImageComponent/ImageComponent';
import { FileAClaimModal } from './components/FileAClaimModal/FileAClaimModal';

type Props = {
    imageUrl: string;
};

export const AskForHelp = ({ imageUrl }: Props) => {
    const trackPurchaseProtectionFileAClaimAnalytics = useTrackPurchaseProtectionFileAClaimAnalytics();
    const [showFileClaimModal, setShowFileClaimModal] = useState(false);
    const { formatMessage } = useIntl();

    return (
        <div className="pb-xl pt-[96px] xsMax:pb-lg xsMax:pt-lg">
            <div className="mx-auto grid max-w-[1200px] grid-cols-2 gap-sm xsMax:grid-cols-1 xsMax:grid-rows-[min-content_min-content] xsMax:gap-md">
                <ImageComponent
                    className="max-h-[330px] xsMax:max-h-[202px]"
                    imageUrl={imageUrl}
                    title="We're here to help"
                />
                <div className="flex flex-col gap-sm pl-[40px] xsMax:pl-0">
                    <H2>{formatMessage({ id: 'purchaseProtectionPage.askForHelp.title' })}</H2>
                    <BodyPrimary>{formatMessage({ id: 'purchaseProtectionPage.askForHelp.description' })}</BodyPrimary>
                    <div className="flex flex-col gap-xs">
                        <H5>{formatMessage({ id: 'purchaseProtectionPage.askForHelp.toQualify' })}</H5>
                        <ul className="list-disc pl-md">
                            <li>
                                <BodyPrimary>
                                    {formatMessage({ id: 'purchaseProtectionPage.askForHelp.itemNotAsDescribed' })}
                                </BodyPrimary>
                            </li>
                            <li>
                                <BodyPrimary>
                                    {formatMessage({ id: 'purchaseProtectionPage.askForHelp.itemNotReceived' })}
                                </BodyPrimary>
                            </li>
                            <li>
                                <BodyPrimary>
                                    {formatMessage({ id: 'purchaseProtectionPage.askForHelp.itemDamaged' })}
                                </BodyPrimary>
                            </li>
                        </ul>
                    </div>
                    <Button
                        className="mt-sm w-fit xsMax:mt-xs xsMax:w-full"
                        onClick={() => {
                            setShowFileClaimModal(true);
                            trackPurchaseProtectionFileAClaimAnalytics({
                                description:
                                    'User clicks on the "File a Claim" button on the Purchase Protection landing page',
                            });
                        }}
                        variant="outlined"
                    >
                        {formatMessage({ id: 'purchaseProtectionPage.askForHelp.fileClaimButton' })}
                    </Button>
                    <FileAClaimModal
                        setShow={setShowFileClaimModal}
                        show={showFileClaimModal}
                    />
                </div>
            </div>
        </div>
    );
};
